import { Box } from "@twilio-paste/core/box";
import { ChevronDownIcon } from "@twilio-paste/icons/esm/ChevronDownIcon";
import { AnimatePresence, motion } from "framer-motion";
import { isMobile } from "react-device-detect";
import { useDispatch, useSelector } from "react-redux";
import { createSelector } from "reselect";
import { changeExpandedStatus } from "../store/actions/genericActions";
import { AppState } from "../store/definitions";
import { EntryPointLogo } from "./EntryPointLogo";
import { containerStyles } from "./styles/EntryPoint.styles";

const entryPointSelector = createSelector(
    (state: AppState) => state,
    (state) => ({
        expanded: state.session.expanded,
        cssOverrides: state.config.theme.cssOverrides?.entryPoint
    })
);

export const EntryPoint = () => {
    const dispatch = useDispatch();
    const { expanded, cssOverrides } = useSelector(entryPointSelector);

    if (isMobile && expanded) {
        return null;
    }

    return (
        <AnimatePresence mode="wait">
            <motion.div
                initial={{
                    opacity: 0,
                    y: 100,
                    scale: 0.3
                }}
                animate={{
                    opacity: 1,
                    y: 70,
                    x: 20,
                    scale: 1
                }}
                exit={{
                    opacity: 0,
                    y: 100,
                    scale: 0.3
                }}
                transition={{
                    type: "spring",
                    stiffness: 260,
                    damping: 20,
                    duration: 0.6
                }}
                whileTap={{
                    scale: 0.95
                }}
                style={{
                    position: 'fixed',
                    bottom: '70px',
                    right: '20px',
                    zIndex: 2147483646,
                    display: 'inline-block'
                }}
            >
                <Box
                    as="button"
                    data-test="entry-point-button"
                    onClick={() => dispatch(changeExpandedStatus({ expanded: !expanded }))}
                    {...containerStyles}
                    _hover={{ ...cssOverrides ?? "colorBackgroundPrimaryStronger" }}
                >
                    <AnimatePresence mode="wait">
                        {expanded ? (
                            <motion.div
                                key="chevron"
                                initial={{ opacity: 0, scale: 0 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0 }}
                                transition={{ duration: 0.15 }}
                            >
                                <ChevronDownIcon decorative={false} title="Minimize chat" size="sizeIcon80" />
                            </motion.div>
                        ) : (
                            <motion.div
                                key="logo"
                                initial={{ opacity: 0, scale: 0 }}
                                animate={{ opacity: 1, scale: 1 }}
                                exit={{ opacity: 0, scale: 0 }}
                                transition={{ duration: 0.15 }}
                                style={{
                                    marginTop: "5px"
                                }}
                            >
                                <EntryPointLogo width="35" height="35" />
                            </motion.div>
                        )}
                    </AnimatePresence>
                </Box>
            </motion.div>
        </AnimatePresence>
    );
};
